import React from 'react';
import './MessageA13Nudge.css';
import apiService from '../../APIService';
import secureLocalStorage from 'react-secure-storage';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const MessageA13Nudge = (props) => {
  const nudges = props.item?.data ? JSON.parse(props.item.data) : [];
  const nudge = nudges[0];

  const callNudgeAPI = (action, nudgeType) => {
    const sessionId = props?.sessionId || secureLocalStorage.getItem("sessionID");
    if (sessionId && nudgeType) {
      apiService.nudgeAction(action, nudgeType, sessionId)
        .then(response => {
          console.log(`Nudge ${action} API response:`, response);
        })
        .catch(error => {
          console.error(`Nudge ${action} API error:`, error);
        });
    }
  };

  const handleAction = (nudge) => {
    callNudgeAPI("Recharge_Redirection", nudge?.nudgeType , "");

    if (nudge?.link) {
      window.open(nudge.link, '_blank');
    }
    
    if (props?.clickedOnToast) {
      props.clickedOnToast();
    }
  };

  const handleClose = () => {
    callNudgeAPI("Recharge_CrossButton", nudge?.nudgeType,);

    if (props?.clickedOnToast) {
      props.clickedOnToast();
    }
  };

  if (!nudge) return null;
 
  
  return (
    <div className="a13-nudge-container">
      <div className="a13-nudge-content">
        <div className="a13-nudge-icon">
        <WarningAmberIcon className="warning-icon" />
        </div>
        <div className="a13-nudge-text">
          <div className="a13-nudge-message">{nudge?.text}</div>
          <button className="a13-nudge-action" onClick={() => handleAction(nudge)}>
            {nudge?.context}
          </button>
        </div>
        <button className="a13-nudge-close" onClick={handleClose}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default MessageA13Nudge;
